import {
    DIC
} from '@/const/dic'
import {
    validateChinese
} from '@/util/validate'
import {
    formatterTime
} from '@/util/util'

export const depositRecordOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [
        {
            label: "充值编号",
            prop: "number",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "充值商户名称",
            prop: "shopName",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "充值法人名称",
            prop: "userName",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "充值账号",
            prop: "account",
            type: "input",

        },
        {
            label: "充值金额",
            prop: "amount",
            type: "input",
        },
        {
            label: "押金解冻规则",
            prop: "ruleId",
            formsolt: true,
            hide: true,
        },
        {
            label: "资金解冻规则",
            prop: "ruleName",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "充值方式",
            prop: "payType",
            type: "radio",
            dicData: DIC.PAY_TYPE,
        },
        {
            label: "充值时间",
            prop: "createTime",
            type: "datetime",
            sortable: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        }
        // {
        //     label: "店铺名称",
        //     prop: "shopName",
        //     type: "input",
        //     addVisdiplay: false,
        //     editVisdiplay: false
        // }
    ]
};